module.exports = __webpack_public_path__ + "static/img/17041B_1_R_20211024_LC.a81b439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17041B_1_R_20211024_LC.png
// module id = m4iH
// module chunks = 0